<template>
  <div>
    <div v-if="$route.path.indexOf('_submit') === -1 && $route.path.indexOf('_editor') === -1">
      <div class="content-bottom-padded">
        <el-button type="primary" icon="el-icon-circle-plus" @click="addTpl" v-if="login_type === 'disti'">添加模板</el-button>

        <el-input v-model="fetchParams.tpl_name" placeholder="问卷标题" class="input-m" @change="getTplList" clearable></el-input>
        <el-date-picker
          clearable
          @change="getTplList"
          v-model="create_time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </div>

      <el-card>
        <el-table :data="tplList" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80px"></el-table-column>
          <el-table-column prop="tpl_name" label="问卷标题"></el-table-column>
          <el-table-column prop="tpl_desc" label="问卷描述"></el-table-column>
          <el-table-column prop="created" label="创建时间">
            <template slot-scope="scope">
              {{scope.row.created | datetime('yyyy-MM-dd hh:mm:ss')}}
            </template>
          </el-table-column>
          <el-table-column label="适用场景" width="150px" v-if="false">
            <template slot-scope="scope">
              <el-tag type="info" v-if="scope.row.scene == '1'"
                >自提订单</el-tag
              >
              <el-tag v-else-if="scope.row.scene == '2'">快递订单</el-tag>
              <el-tag type="success" v-else>兑换券核销</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否启用" v-if="false">
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.is_open == '0'">禁用</el-tag>
              <el-tag type="success" v-else>启用</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="240" label="操作">
            <template slot-scope="scope">
              <div class="operating-icons">
                <div>
                  <el-button
                    type="text"
                    class="op_btn"
                    @click="openRightsSetting(scope.row)">
                    关联权益
                  </el-button>
                  <el-button
                    type="text"
                    class="op_btn"
                    @click="openCompletePageSetting(scope.row)">
                    提交完成页模版
                  </el-button>
                  <span v-if="login_type == 'disti'"><router-link :to="{path: matchHidePage('editor'), query: { id: scope.row.id }}">编辑</router-link></span>
                  <!-- <el-button type="text" @click="openDialog(scope.row)">预览</el-button> -->
                  <el-button
                    type="text"
                    class="op_btn"
                    @click="delTpl(scope.row.id)">
                    删除
                  </el-button>
                  <span v-if="login_type == 'disti'"><router-link :to="{path: matchHidePage('submit'), query: { id: scope.row.id }}">统计</router-link></span>
                </div>

              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :total='pagers.total'
            :page-size="pageSize">
          </el-pagination>
        </div>
      </el-card>

    </div>
    <router-view></router-view>

    <!-- 关联权益设置弹窗 -->
    <SpDialog
      ref="rightsDialogRef"
      v-model="rightsDrawerVisible"
      title="问卷完成赠送权益设置"
      width="600px"
      label-width="150px"
      :form="rightsForm"
      :form-list="rightsFormList"
      :loading="rightsSaving"
      @onSubmit="saveRightsSetting"
    />

    <!-- 提交完成页模版设置弹窗 -->
    <SpDialog
      ref="completePageDialogRef"
      v-model="completePageDrawerVisible"
      title="问卷完成模版页设置"
      width="500px"
      label-width="150px"
      :form="completePageForm"
      :form-list="completePageFormList"
      :loading="completePageSaving"
      @onSubmit="saveCompletePageSetting"
    />
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import util from '../../../common/js/util'
import SpDialog from '@/components/sp-dialog'

import {
  getQuestionnairetplList,
  delQuestionnairetpl,
} from '@/api/wxa'


export default {
  
  components: {
    SpDialog
  },
  provide() {
    return {
      refresh: this.getTplList
    }
  },
  data () {
    return {
      loading: false,
      checkedType: {},
      tplList: [],
      operator_type:'',
      pagers:{
        total: 0
      },
      pageSize:10,
      currentPage:1,
      params: {},
      fetchParams: {
        currentPage: 1,
        pageSize: 10,
        tpl_name: '',
        start_time: '',
      },
      create_time: [],
      // 关联权益设置相关
      rightsDrawerVisible: false,
      rightsSaving: false,
      currentQuestionnaireId: null,
      rightsForm: {
        is_open: false,
        target_type: [],
        activity_id: '',
        resend_days: 0
      },
      rightsRules: {
        activity_id: [
          { 
            validator: (rule, value, callback) => {
              if (this.rightsForm.is_open && !value) {
                callback(new Error('请选择CRM会员权益'))
              } else {
                callback()
              }
            }, 
            trigger: 'change' 
          }
        ]
      },
      completePageList: [],
      crmRightsList: [],
      // 提交完成页模版设置相关
      completePageDrawerVisible: false,
      completePageSaving: false,
      completePageForm: {
        page_id: ''
      },
      // SpDialog 表单列表
      rightsFormList: [],
      completePageFormList: [],
    }
  },
  computed: {
    ...mapGetters([
      'wheight',
      'login_type'
    ])
  },
  methods: {
    handleCurrentChange(val) {
      this.fetchParams.currentPage = val
      this.getTplList()
    },
    handleSizeChange (val) {
      this.fetchParams.pageSize = val
      this.getTplList()
    },
    addTpl () {
      this.$router.push({path: this.matchHidePage('editor')})
    },
    chooseType (item, index) {
      this.i = index
      this.checkedType = item
    },
    delTpl (id) {
      this.$confirm('确定要删除该问卷模板？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            delQuestionnairetpl(id).then( res => {
              this.$message({ type: 'success', message: '操作成功！' })
              this.getTplList()
            })
          }
        done()
        }
      })
    },
    getTplList () {
      this.loading = true
      let params = {
        page: this.fetchParams.currentPage,
        page_size: this.fetchParams.pageSize,
        tpl_name: this.fetchParams.tpl_name,
        create_time: this.create_time,
      }
      getQuestionnairetplList(params).then(res => {
        if(res.data.data.list.length > 0) {
          this.tplList = res.data.data.list
          this.pagers.total = res.data.data.total_count
          this.loading = false
        } else {
          this.tplList = []
          this.loading = false
        }
      })
      .catch( error => {
        this.loading = false
      })
    },
    // 打开关联权益设置
    openRightsSetting(row) {
      this.currentQuestionnaireId = row.id
      this.loadCrmRightsList()
      this.loadRightsSetting(row.id)
      this.rightsDrawerVisible = true
    },
    // 加载关联权益设置
    async loadRightsSetting(id) {
      try {
        const data = await this.$api.wxa.getEquityConfig({tpl_id: id})
        console.log(data, 'data')
        this.rightsForm = {
          is_open: data.is_open,
          target_type: data.target_type.split(','),
          activity_id: data.activity_id || '',
          resend_days: data.resend_days
        }
      } catch (error) {
        console.log(error, 'error')
        this.resetRightsForm()
      }
    },
    // 重置关联权益表单
    resetRightsForm() {
      this.rightsForm = {
        is_open: false,
        target_type: [],
        activity_id: '',
        resend_days: 0
      }
    },
    // 加载CRM会员权益列表
    async loadCrmRightsList() {
      try {
        const data = await this.$api.wxa.getCrmMemberRightsList({ page: 1, page_size: 100 })
        this.crmRightsList = data.list.map(item => ({
          value: String(item.equityActivityId),
          title: item.name
        }))
      } catch (error) {
        console.log(error, 'error')
        this.crmRightsList = []
      }
      this.rightsFormList = [
        {
          label: '关联权益',
          key: 'is_open',
          type: 'switch',
          onChange: (val) => {
            this.handleRightsEnableChange(val)
          }
        },
        {
          label: '适用对象',
          key: 'target_type',
          type: 'checkbox',
          disabled: true,
          options: [
            { label: 'crm', name: '会员' }
          ],
          isShow: () => this.rightsForm.is_open
        },
        {
          label: 'CRM会员权益',
          key: 'activity_id',
          type: 'select',
          placeholder: '请选择CRM会员权益',
          options: this.crmRightsList || [],
          validator: (rule, value, callback) => {
            if (this.rightsForm.is_open && !value) {
              callback(new Error('请选择CRM会员权益'))
            } else {
              callback()
            }
          },
          isShow: () => this.rightsForm.is_open
        },
        {
          label: '补发节点',
          key: 'resend_days',
          isShow: () => this.rightsForm.is_open,
          component: ({ key }) => {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                <span>完成</span>
                <el-select v-model={this.rightsForm[key]} placeholder="请选择">
                  <el-option value={0} label="当天"></el-option>
                  <el-option value={1} label="次日"></el-option>
                </el-select>
                <span>入会</span>
              </div>
            )
          }
        }
      ]
    },
    // 关联权益开关变化
    handleRightsEnableChange(val) {
      if (val) {
        // 开启时，默认选中会员
        if (this.rightsForm.target_type.indexOf('crm') === -1) {
          this.rightsForm.target_type.push('crm')
        }
      }
    },
    // 保存关联权益设置
    async saveRightsSetting() {
      if (this.rightsForm.is_open && !this.rightsForm.activity_id) {
        this.$message.warning('开启关联权益时，CRM会员权益为必选项')
        return false
      }
      
      this.rightsSaving = true
      const params = {
        tpl_id: this.currentQuestionnaireId,
        is_open: this.rightsForm.is_open,
        target_type: this.rightsForm.target_type.join(','),
        activity_id: this.rightsForm.activity_id,
        activity_name: this.crmRightsList.find(item => item.value === this.rightsForm.activity_id).title || '',
        resend_days: this.rightsForm.resend_days,
      }

      try {
        await this.$api.wxa.saveEquityConfig(params)
        this.$message.success('保存成功')
        this.rightsDrawerVisible = false
        this.rightsSaving = false
        this.resetRightsForm()
        this.getTplList()
        this.currentQuestionnaireId = null
      } catch (error) {
        this.$message.error('保存失败')
        this.rightsSaving = false
      }
    },
    // 打开提交完成页模版设置
    openCompletePageSetting(row) {
      this.currentQuestionnaireId = row.id
      this.loadCustomPageList(row.id)
      this.loadCompletePageSetting(row.id)
      this.completePageDrawerVisible = true
    },
    async loadCustomPageList () {
      try {
        const  params = JSON.parse(JSON.stringify({ page: 1, pageSize: 100 }))
        const data = await this.$api.wxa.getCustomPageList(params)
        console.log(data, 'data')
        this.completePageList = data.list.map(item => ({
          value: item.id,
          title: item.page_name
        }))
        console.log(data.list, this.crmRightsList, 'data')
      } catch (error) {
        console.log(error, 'error1')
        this.completePageList = []
      }
      this.completePageFormList = [
        {
          label: '问卷完成页模版',
          key: 'page_id',
          type: 'select',
          placeholder: '请选择完成页模版',
          options: this.completePageList || [],
          clearable: true,
          // required: true,
          // message: '请选择问卷完成页模版'
        }
      ]
    },
    // 加载提交完成页模版设置
    async loadCompletePageSetting(id) {
      try {
        const data = await this.$api.wxa.getCompletePageSetting({tpl_id: id})
        this.completePageForm = data
      } catch (error) {
        this.completePageForm = {
          page_id: ''
        }
      }
    },
    // 保存提交完成页模版设置
    async saveCompletePageSetting() {
      this.completePageSaving = true
      const params = {
        tpl_id: this.currentQuestionnaireId
      }
      if (this.completePageForm.page_id) {
        params.page_id = this.completePageForm.page_id
        params.page_name = this.completePageList.find(item => item.value === this.completePageForm.page_id).title || ''
      }
      try {
        await this.$api.wxa.saveCompletePageSetting(params)
        this.$message.success('保存成功')
        this.completePageDrawerVisible = false
        this.completePageSaving = false
        this.completePageForm = {
          page_id: ''
        }
        this.getTplList()
        this.currentQuestionnaireId = null
      } catch (error) {
        this.$message.error('保存失败')
        this.completePageSaving = false
      }
    }
  },
  mounted () {
    this.fetchParams.store_self = false
    if (this.system_mode === 'platform' && store.getters.login_type !== 'distributor') {
      this.fetchParams.store_self = true
    }
    this.operator_type = store.getters.login_type;
    this.getTplList()
  }
}

</script>
<style scoped lang="scss">
  .el-icon-edit {
    cursor: pointer;
  }
  .coupon-list {
    margin-top: 10px;
  }
  .coupon-item {
    position: relative;
    height: 130px;
    padding: 25px 20px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dadadd;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    width: 19%;
    float: left;
    margin: .5%;
    &.coupon-add {
      padding-top: 20px;
      cursor: pointer;
      i {
        font-size: 40px;
      }
      :last-child { margin-top: 10px; }
    }
    .price {
      font-size: 24px;
    }
    .color-gray {
      color: #99A9BF;
    }
    .color-gray-deep {
      color: #8492A6;
    }
    .item-code {
      display: inline-block;
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span.icon-triangle {
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: 34px solid #20a0ff;
      border-left: 34px solid transparent;
      color: #fff;
    }
    label {
      position: absolute;
      top: -34px;
      right: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }
  }
  .item-bg {
    position: absolute;
    left: 0;
    bottom: -101%;
    width: 100%;
    height: 100%;
    background: rgba(241, 244, 246, .9);
    text-align: left;
    border-radius: 5px;
    padding-top: 8px;
    transition: all .4s ease;
    p {
      padding: 0 10px;
    }
    .item-operate {
      position: absolute;
      left: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .4);
      width: 100%;
      padding: 4px 0;
      text-align: center;
      cursor: pointer;
      a { color: #fff; }
    }
  }
  .coupon-item:hover {
    .item-bg {
      bottom: 0;
    }
  }
  .coupon-type-item {
    position: relative;
    padding: 30px 10px;
    border: 1px solid #ff5000;
    color: #ff5000;
    border-radius: 5px;
    text-align: center;
    margin-bottom: 20px;
    background: #fff;
    overflow: hidden;
    cursor: pointer;
    &:first-child {
      font-size: 18px;
    }
    .coupon-type-desc {
      position: absolute;
      width: 100%;
      height: 100%;
      bottom: -100%;
      left: 0;
      padding: 10px 0;
      background: #ff5000;
      color: #fff;
      font-size: 18px;
      transition: all .4s ease;
      div:last-child {
        width: 70%;
        margin: 8px auto 0;
        font-size: 12px;
      }
    }
    &:hover {
      .coupon-type-desc {
        bottom: 0;
      }
    }
  }

  .coupon-type-item, .sendout-item {
    overflow: hidden;
    .icon-checked {
      display: none;
      width: 100px;
      height: 25px;
      transform: rotate(35deg);
      position: absolute;
      top: 5px;
      right: -25px;
      font-size: 20px;
      color: #fff;
      background: #ff5000;
      i {
        transform: rotate(-35deg);
      }
    }
    &.checked {
      .icon-checked {
        display: block;
      }
    }

    &:hover .icon-checked {
      background: #fff;
      i {
        color: #ff5000;
      }
    }
  }
  .store-pop {
    padding: 20px 15px;
    .store-content {
      margin-bottom: 15px;
    }
  }
  .subtitle{
    color: #8c939d;
    margin-top: 3px;
    font-size: 10px;
  }
  .dialog-content {
    padding: 10px 0;
  }
</style>
